import React from "react";
// react prop types
import PropTypes from "prop-types";
// icons
import { Close, Image, ArrowDownward } from '@material-ui/icons'

// material ui core organization components
import {
  Table,
  TableCell,
  TableRow,
  Button,
  TextField,
  IconButton
} from '@material-ui/core';

// react modal
import Modal from 'react-modal';
// react redux connect
import { connect } from 'react-redux';
// js moment
import moment from 'moment';
// redux actions
import {
  loadChats,
  createNewChat,
  updateChatMetadata,
  sendImageToChat,
} from './reducer/actions';
// material ui with styles
import { withStyles } from '@material-ui/core/styles';
// icon image import
import GK from '../../assets/img/gk.png';
// redirect if not admin
import { Redirect } from "react-router-dom";
// format phone number
import phoneFormatter from 'phone-formatter';


// theme style
const styles = theme => ({
  /* main table */
  table: {
    width: '100%',
    backgroundColor: 'white',
  },
  /* individual rows */
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  cell: {
    width: '20%',
  },
  /* big View Messages button */
  button: {
    background: '#3399ff',
    color: 'white',
    width: 140,
    height: 30,
    borderRadius: 5,
    fontSize: 12,
    fontWeight: 'bold',
    marginLeft: 10,
    marginTop: 5,
  },
  /* small Send Messages button */
  smallButton: {
    background: '#3399ff',
    color: 'white',
    width: 120,
    height: 30,
    borderRadius: 5,
    fontSize: 12,
    fontWeight: 'bold',
    marginRight: 5,
    paddingRight: 5,
  },
  /* modal Close button */
  closeButton: {
    backgroundColor: 'yellow',
    width: 40,
    height: 40,
    position: 'absolute',
    top: 20,
    right: 20,
    alignItems: "center",
    justifyContent: 'center',
  },
  /* modal Close button */
  uploadButton: {
    background: '#3399ff',
    width: 40,
    height: 40,
  },
  sortButton: {
    backgroundColor: '#CDCDCD',
    width: 25,
    height: 25,
    marginLeft: 5,
    alignItems: "center",
    justifyContent: 'center',
  },
  /* message sent by admin styles */
  sentMessage: {
    float: 'right',
    clear: 'both',
    padding: 10,
    maxWidth: '80%',
    backgroundColor: 'blue',
    color: 'white',
    borderRadius: 10,
    margin: 10,
  },
  /* message recieved from user styles */
  recievedMessage: {
    padding: 10,
    maxWidth: '80%',
    backgroundColor: 'green',
    color: 'white',
    borderRadius: 10,
    margin: 10,
    float: 'left',
    clear: 'both',
  },
  /* text for headers and nav bars */
  headerText: {
    fontSize: 21,
    fontFamily: 'Source Sans Pro',
    fontWeight: 'bold',
    paddingTop: 5,
    paddingBottom: 10,
  },
  /* modal message container style */
  messageContainer: {
    width: 600,
    height: 720,
    backgroundColor: 'black',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  /* modal bottom message sender block style */
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'gray',
    minHeight: 20,
    maxHeight: 100,
    width: 600,
  },
  /* message input box style */
  messageInput: {
    backgroundColor: 'white',
    minHeight: 20,
    maxHeight: 80,
    width: 400,
  },
  /* set image maximum width for chats */
  image: {
    maxWidth: 300,
  }
});

// modal content and overlay style
const modalStyles = {
  content: {
    left: '30%',
    width: 580,
    height: 790,
    backgroundColor: 'black',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent'
  },
};

// My brother was imprisoned for running through the flowerbed.
// My sister was killed for putting too much butter on her scone.

// component declaration
class Dashboard extends React.Component {
  state = {
    display: 0,
    unread: true,
    index: -1,
    message: '',
    showModal: false,
    key: null,
    sortMethod: 0,
  };

  // load in the chats
  componentDidMount() {
    this.props.loadChats(this.success, this.error);
  }

  // whenever a new message is sent/recieved, scroll to bottom
  // if there's a new message, from user, send out a notification
  componentDidUpdate(prevProps) {
    if (this.state.message.length !== '') {
      return true;
    }
    else if (this.state.showModal === true) {
      this.scrollToBottom();
    }
    // if user has accepted recieving notifications
    if (Notification.permission === 'granted') {
      // get previous chats and new chats
      // TODO: test for read chats
      // TODO: if Body Text has not been changed, don't send
      const oldUnreadChats = prevProps.unreadChats;
      const newUnreadChats = this.props.unreadChats;
      // get their keys
      const oldKeys = Object.keys(oldUnreadChats);
      const newKeys = Object.keys(newUnreadChats);
      // if there are more keys than before, there's a new chat
      if (oldKeys.length !== newKeys.length) {
        // text of notification to send
        let bodyText = "New message in GK Support Chat from ";
        // whether the new user object has any Messages yet
        var messages = true;
        // loop through
        for (let n = 0; n < newKeys.length; ++n) {
          // find the key that's in new but not in old
          if (!oldKeys.hasOwnProperty(newKeys[n])) {
            // add the name to the body text
            bodyText = bodyText + newUnreadChats[newKeys[n]].name;
            // make sure there are messages
            // if a user isn't signed in, then there may not be.
            messages = newUnreadChats[newKeys[n]].hasOwnProperty('messages');
            // end the loop
            break;
          }
        }
        // if there are messages, send the notification
        if (messages) {
          let notif = new Notification('Alert', { body: bodyText, icon: GK });
          setTimeout(notif.close.bind(notif), 4000);
        }
        // return immediately
        return;
      }
      // if no new keys, might be a new message from an existing user
      else {
        // iterate through all chats
        for (let o = 0; o < oldKeys.length; ++o) {
          // get old version of chat
          let oldChat = oldUnreadChats[oldKeys[o]];
          // get new version of chat
          let newChat = newUnreadChats[oldKeys[o]];
          // if the new chat has no messages, proceed to next iteration
          if (!newChat.hasOwnProperty('messages')) {
            continue;
          }
          else {
            // get new messages
            let newMessages = newChat.messages;
            // get old messages (or empty array)
            let oldMessages = oldChat.messages || [];
            // if there are more new messages than old messages
            if (newMessages.length > oldMessages.length) {
              // get the newest message
              let newestMessage = newMessages[newMessages.length - 1];
              // if there are exactly two messages (user's and automated)
              // or the latest message is from the user
              if (newMessages.length === 2 || newestMessage.user._id === 1) {
                // create and send notification
                var bodyText = "New message in GK Support Chat from ";
                bodyText = bodyText + newChat.name;
                let notif = new Notification('Alert', { body: bodyText, icon: GK });
                setTimeout(notif.close.bind(notif), 4000);
                return;
              } // end of nested if
            } // end of else-if
          } // end of else
        } // end of for loop
        return;
      }
    }
  }

  askPermission() {
    Notification.requestPermission().then(function(permission) {
      if(!('permission' in Notification)) {
        Notification.permission = permission;
      }
      let notif = new Notification('Alert', { body: 'You are now subscribed.', icon: GK});
      setTimeout(notif.close.bind(notif), 4000);
    });
  }

  // open modal
  openModal(i, uid) {
    this.setState({
      showModal: true,
      index: i,
      key: uid,
    })
    // scroll to bottom of chat after half a second
    setTimeout(() => this.scrollToBottom(), 500);
  }

  // close modal
  closeModal() {
    this.setState({
      showModal: false,
      index: -1,
      key: null,
    })
  }

  // scroll to bottom of message view, if it exists
  scrollToBottom = () => {
    if (this.messagesEnd) {
      this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
  }

  // function called on success
  success = () => { console.log('loaded') }

  // function called on error
  error = () => { console.log('failed to load')}

  // send out a message to a user
  sendMessage() {
    // get the location of the chat
    let index = this.state.index;
    // get which chats are being looked at
    let chats = this.state.unread ? this.props.unreadChats : this.props.readChats;
    // get the messages from the chat
    let messages = chats[index].messages;
    // assemble chat data
    let data = {
      _id: messages.length,
      createdAt: Date.now(),
      text: this.state.message,
      user: {
        _id: 2,
      },
      uid: this.state.key,
    };
    // send to reducer
    this.props.createNewChat(data, this.success, this.error)
    // reset message state
    this.setState({message: ''});
  }

  // mark a message Resolved or not Resolved
  markStatus(key) {
    const data = { unread: !this.state.unread, key: key}
    this.props.updateChatMetadata(data, this.success, this.error);
  }

  // assign handling a chat to the current Admin
  assignToMe(key) {
    const email = this.props.email;
    const data = { assigned: email, key: key };
    this.props.updateChatMetadata(data, this.success, this.error);
  }

  uploadImage(key) {
    // get the location of the chat
    let index = this.state.index;
    // get which chats are being looked at
    let chats = this.state.unread ? this.props.unreadChats : this.props.readChats;
    // get the messages from the chat
    let messages = chats[index].messages;
    let length = messages.length;
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/gif, image/jpeg, image/png");
    input.addEventListener("change", ({target: {files: [file]}}) => {
      let data = { image: file, key: key, index: length};
      this.props.sendImageToChat(data, this.success, this.error);
    });
    input.click();
  }

  // render modal with messages to/from a user
  renderMessages() {
    const {
      classes
    } = this.props;
    // whether viewing Read or Unread messages
    let read = this.state.unread;
    // index of user
    let index = this.state.index;
    // if no user has been selected, return
    if (index === -1) {
      return null;
    }
    // select chats depending on state
    let chats = read ? this.props.unreadChats : this.props.readChats;
    // get messages from chats
    let messages = chats[index].messages;
    // get chat history
    var history = [];
    // iterate through messages
    if (messages) {
      for (let m = 0; m < messages.length; ++m) {
        // if messages sent by admin, use one style
        let message = messages[m];
        let body = "";
        if (message.messageType === 'image') {
          body = (
            <img
              src={message.image}
              alt={'chat'}
              class={classes.image}
            />
          );
        }
        else {
          body = message.text;
        }
        if (message.user._id === 2) {
          history.push(
            <div className={classes.sentMessage}>
              { body }
            </div>
          );
        }
        // if messages sent by user, use other style
        else {
          history.push(
            <div className={classes.recievedMessage}>
              { body }
            </div>
          );
        }
      }
    }
    // add a div to the bottom to scroll to automatically
    history.push(
      <div style={{ float:"left", clear: "both" }}
        ref={(el) => { this.messagesEnd = el; }}
      />
    );
    // return modal
    return (
      <Modal
        isOpen={this.state.showModal}
        onRequestClose={this.closeModal.bind(this)}
        style={modalStyles}
        ariaHideApp={false}
      >
        {/* show chat history at bottom */}
        <div className={classes.messageContainer}>
          { history }
          <IconButton tooltip="Return to Message Select"
            onClick={()=> this.closeModal() }
            className={classes.closeButton}
          >
            <Close />
          </IconButton>
        </div>
        {/* bottom container with input options */}
        <div className = {classes.inputContainer}>
          {/* message input block */}
          <div className = {classes.messageInput}>
            <TextField
              onChange={(e)=>this.setState({ message: e.target.value })}
              value={this.state.message}
              fullWidth
              multiline
              rowsMax={4}
            />
          </div>
          {/* Send Image button */}
          <IconButton tooltip="Send Image in Chat"
            onClick={()=> this.uploadImage(this.state.key) }
            className={classes.uploadButton}
          >
            <Image />
          </IconButton>
          {/* send button */}
          <Button className={classes.smallButton}
            onClick={()=> this.sendMessage()}
          >
            SEND
          </Button>
        </div>
      </Modal>
    );
  }

  // sort through chats
  sortedChats() {
    const {
      unreadChats,
      readChats,
    } = this.props;
    let chats = this.state.unread ? unreadChats : readChats;
    let sortMethod = this.state.sortMethod;
    switch(sortMethod) {
      case 0:
        // sort by given name
        chats.sort((a, b) => {
          if (a.hasOwnProperty('name') && b.hasOwnProperty('name')) {
            if (a.name === '') {
              return 1;
            }
            if (b.name === '') {
              return 0;
            }
            return a.name.localeCompare(b.name);
          }
          return 0;
        });
        break;
      case 1:
        // sort based on who messages are assigned to
        chats.sort((a, b) => {
          if (a.hasOwnProperty('assigned') && b.hasOwnProperty('assigned')) {
            return a.assigned.localeCompare(b.assigned);
          }
          else if (a.hasOwnProperty('assigned')) {
            return 0;
          }
          else if (b.hasOwnProperty('assigned')) {
            return 1;
          }
          else {
            return a.name.localeCompare(b.name);
          }
        });
        break;
      case 2:
        // sort based on app of origin
        chats.sort((a, b) => {
          return a.from.localeCompare(b.from);
        });
        break;
      case 3:
        // sort based on when the last message was sent
        // if both have messages, return the one that was sent more recently
        chats.sort((a, b) => {
          if (a.hasOwnProperty('messages') && b.hasOwnProperty('messages')) {
            let aMessages = a.messages;
            let bMessages = b.messages;
            let aLast = aMessages[aMessages.length - 1];
            let bLast = bMessages[bMessages.length - 1];
            return (aLast.createdAt < bLast.createdAt);
          }
          else if (a.hasOwnProperty('messages')) {
            return 0;
          }
          else if (b.hasOwnProperty('messages')) {
            return 1;
          }
          else {
            return a.name.localeCompare(b.name);
          }
        });
        break;
      default:
        // if 0, default sorting
        // if something other than 0-3, break
        break;
    }
    return chats;
  }

  // render all chats
  renderChats() {
    const {
      classes,
    } = this.props;
    // chats to render
    let process = this.sortedChats();
    // array to return
    let chats = [];
    // top block of field descriptions
    // TODO: allow sorting from top headers?
    chats.push(
      <TableRow className={classes.row}>
        <TableCell className={classes.cell}>
          User Name
          <IconButton tooltip="Sort by User Name"
            onClick={()=> this.setState({sortMethod: 0}) }
            className={classes.sortButton}
          >
            <ArrowDownward />
          </IconButton>
        </TableCell>
        <TableCell className={classes.cell}>
          Assigned To:
          <IconButton tooltip="Sort by User Name"
            onClick={()=> this.setState({sortMethod: 1}) }
            className={classes.sortButton}
          >
            <ArrowDownward />
          </IconButton>
        </TableCell>
        <TableCell className={classes.cell}>
          Origin App
          <IconButton tooltip="Sort by User Name"
            onClick={()=> this.setState({sortMethod: 2}) }
            className={classes.sortButton}
          >
            <ArrowDownward />
          </IconButton>
        </TableCell>
        <TableCell className={classes.cell}>
          Last Message Sent
          <IconButton tooltip="Sort by User Name"
            onClick={()=> this.setState({sortMethod: 3}) }
            className={classes.sortButton}
          >
            <ArrowDownward />
          </IconButton>
        </TableCell>
        <TableCell className={classes.cell}>
          Actions
        </TableCell>
      </TableRow>
    );
    // add each Chat
    for (let c = 0; c < process.length; ++c) {
      let chat = process[c];
      chats.push(
        <TableRow className={classes.row}>
          {/* display user's Name, Email, and phone number */}
          <TableCell className={classes.cell}>
            { chat.name }
            <br />
            { chat.email }
            {
              chat.phone ?
              <span>
                <br />
                {
                  chat.phone.length >= 10 ?
                    phoneFormatter.format(chat.phone, '(NNN) NNN-NNNN')
                  :
                    chat.phone
                }
              </span>
              : null
            }
          </TableCell>
          {/* who is assigned to resolve the user's difficulties */}
          <TableCell className={classes.cell}>
            { chat.assigned ? chat.assigned : chat.unread ? 'UNREAD' : 'READ' }
          </TableCell>
          {/* the app from which the chat originated */}
          <TableCell className={classes.cell}>
            { chat.from }
          </TableCell>
          {/* when the most recent message was sent */}
          <TableCell className={classes.cell}>
            { chat.messages ? String(moment(chat.messages[chat.messages.length - 1].createdAt)) : '' }
          </TableCell>
          {/* action buttons */}
          <TableCell className={classes.cell}>
            {/* opens modal to begin chat */}
            <Button className={classes.button}
              onClick={()=> this.openModal(c, chat.key) }
            >
              VIEW MESSAGES
            </Button>
            {/* mark chat as resolved */}
            <Button className={classes.button}
              onClick={()=> this.markStatus(chat.key) }
            >
              { this.state.unread ? 'MARK READ' : 'UNREAD'}
            </Button>
            {/* mark chat as managed by admin */}
            <Button className={classes.button}
              onClick={()=> this.assignToMe(chat.key) }
            >
              ASSIGN TO ME
            </Button>
          </TableCell>
        </TableRow>
      )
    }
    // return the array
    return (
      <Table>
        { chats }
      </Table>
    );
  }

  // component render method
  render() {
    const {
      classes
    } = this.props;

    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'dashboard'} to={''} key={'invalid'} />
      );
    }

    return (
      <div>
        <Button className={classes.button}
          onClick={()=> this.setState({unread: !this.state.unread})}
        >
          { this.state.unread ? 'VIEW READ' : 'VIEW UNREAD'}
        </Button>
        { Notification.permission === 'default' ?
          <Button className={classes.button}
            onClick={()=> this.askPermission()}
          >
            NOTIFY ME
          </Button>
          : null
        }
        { this.renderChats() }
        { this.renderMessages() }
      </div>
    );
  }
}

// set proptypes
Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

// map state to props
const mapStateToProps = (state) => {
  const chats = state.chatReducer.chats;
  // array of chats that have been read by support
  var readChats = [];
  // chats not yet read by support
  var unreadChats = [];
  // iterate through all chats
  if (!Array.isArray(chats)) {
    // get keys
    const keys = Object.keys(chats);
    // iterate through keys
    for (let k = 0; k < keys.length; ++k) {
      let chat = chats[keys[k]];
      // set key for later use
      chat.key = keys[k];
      // if unread, push to unread
      if (chat.unread === true) {
        unreadChats.push(chat);
      }
      // if read, push to read
      else if (chat.unread === false){
        readChats.push(chat);
      }
    }
  }
  // get user's email to allow Assignment
  let email = '';
  if (state.authReducer.user) {
    if (state.authReducer.user.hasOwnProperty('email')) {
      email = state.authReducer.user.email;
    }
  }
  // return props to component
  return {
    readChats,
    unreadChats,
    email,
    user: state.authReducer.user,
  }
};
// map load chats and create new chat to props
const mapDispatchToProps = {
  loadChats,
  createNewChat,
  updateChatMetadata,
  sendImageToChat,
};
// connect
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Dashboard));
